/**
 * Tipi per ricerche - SPECIFICHE 3.1
 *
 * Tutte le ricerche restituiscono LavoratoreCompleto con posizioni raggruppate.
 * Schema Zod: condivisi tra server e client per validazione runtime.
 */
import { z } from 'zod';
import { CassaCodeSchema, StatoLavoratoreSchema, str, dateStr } from './common.ts';

/**
 * Posizione attuale con dati impresa (per visualizzazione)
 */
export const PosizioneAttualeSchema = z.object({
  cassa: CassaCodeSchema,
  periodo: z.string(),
  stato: StatoLavoratoreSchema,
  sindacato: str,
  qualifica: str,
  codce: str,
  impresaId: z.number().nullable(),
  impresaRagioneSociale: str,
  impresaCodImp: str,
  dataAssunzione: str,
  dataCessazione: str,
});

export type PosizioneAttuale = z.infer<typeof PosizioneAttualeSchema>;

/**
 * Lavoratore completo con posizioni raggruppate per cassa.
 * Usato da tutte le ricerche (SPECIFICHE 3.2).
 */
export const LavoratoreCompletoSchema = z.object({
  id: z.number(),
  codiceFiscale: str,
  cognome: z.string(),
  nome: z.string(),
  sesso: str,
  dataNascita: dateStr,
  comuneNascita: str,
  provinciaNascita: str,
  via: str,
  cap: str,
  comune: str,
  provincia: str,
  telefono: str,
  cellulare: str,
  email: str,
  posizioni: z.object({
    CE: PosizioneAttualeSchema.optional(),
    EC: PosizioneAttualeSchema.optional(),
  }),
});

export type LavoratoreCompleto = z.infer<typeof LavoratoreCompletoSchema>;

/**
 * Periodo storico raggruppato (per storicità lavoratore)
 */
export const PeriodoStoricoSchema = z.object({
  cassa: z.string(),
  periodoInizio: z.string(),
  periodoFine: z.string(),
  ragioneSociale: str,
  stato: str,
  sindacato: str,
  qualifica: str,
  dataAssunzione: str,
  dataCessazione: str,
});

export type PeriodoStorico = z.infer<typeof PeriodoStoricoSchema>;
